import { CART_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";
import { IHDCartAddressClusterChangeResponse } from "@/api_framework/api_modals/Cart";
import { setHDAddressClusterChange } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});

export const useHDAddressClusterChangeAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (newAddressId: string, oldAddressId: string, customerId: string) => {
      try {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(
            `${CART_MODULE?.HD_ADDRESS_CLUSTER_CHANGE?.baseURL}?new_address_id=${newAddressId}&old_address_id=${oldAddressId}&customer_id=${customerId}`,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IHDCartAddressClusterChangeResponse>) => {
            if (res.data.status === true) {
              dispatch(setHDAddressClusterChange({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: true, message: res.data.message, data: res.data.data };
            } else {
              dispatch(setHDAddressClusterChange({ data: null }));
              dispatch(
                setLoading({
                  key: "isvaccinationTableLoading",
                  status: false,
                }),
              );
              return { status: false, message: null, data: null };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setHDAddressClusterChange(null));
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isvaccinationTableLoading",
                status: false,
              }),
            );
            const message = e.response.data as any;
            return { status: false, message: message, data: null };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: false,
          }),
        );
        dispatch(setHDAddressClusterChange(null));
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
